export default function (remoteMeasures, skipKeys = ['help_remote_ready']) {
    let score = 0

    const ignoreKeys = [
        'has_tech_team',
    ]

    // Some remote_measures params passed in are without company_id | created_at | id | updated_at
    if (remoteMeasures?.company_id) ignoreKeys.push('company_id')
    if (remoteMeasures?.created_at) ignoreKeys.push('created_at')
    if (remoteMeasures?.id) ignoreKeys.push('id')
    if (remoteMeasures?.updated_at) ignoreKeys.push('updated_at')

    skipKeys.forEach(key => ignoreKeys.push(key))

    if (!remoteMeasures.has_tech_team) {
        ['schedule_regular_scrums', 'uses_git']
            .forEach(key => ignoreKeys.push(key))
    }

    const totalValidKeys = Object.keys(remoteMeasures).length - ignoreKeys.length

    for (let key in remoteMeasures) {
        if (ignoreKeys.indexOf(key.toLowerCase()) == -1 && remoteMeasures[key]) {
            score++
        }
    }

    return score / totalValidKeys > 1 ? 0 : Math.round((score / totalValidKeys) * 100)
}
